import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <AppSection />
        <FAQSection />
        <CarouselSection />
        <MediaSection />
        <CardsSection />
        <ContactSection />
        <AboutSection />
        <TopicsSection />
        <FeaturesSection />
        <CommentsSection />
        <UpdatesSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}